var _line, _line2, _line3, _line4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAny(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 10,
    x2: 16,
    y2: 10,
    stroke: "#263238",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 4,
    x2: 10,
    y2: 16,
    stroke: "#263238",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 6,
    x2: 14,
    y2: 14,
    stroke: "#263238",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 14,
    x2: 14,
    y2: 6,
    stroke: "#263238",
    strokeWidth: 2
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAny);
export default __webpack_public_path__ + "static/media/Any.7a8c3f8aa34651813cd31d4bd47ee1ea.svg";
export { ForwardRef as ReactComponent };